module.exports = __webpack_public_path__ + "img/rifle.l96.893ae535.png";